module.exports = __webpack_public_path__ + "static/media/guitars.423c2a16.svg";